import { Routes } from '@angular/router';

import { PermissionsList } from '../../shared/common/PermissionList';
import { DashboardGuard } from 'src/app/core/auth/guards/dashboard.guard';

export const DashboardRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardPageComponent),
    title: 'Dashboard | ADROIT',
    data: {
      animation: 'home',
      PermissionPageName: [PermissionsList[PermissionsList.ClientHomeView]],
    },
    canActivate: [DashboardGuard],
  },
];
